import { assignImgixLogo, defaultImigxParams, imgixUrl } from '@uswitch/comms-ui.image'
import { buildURL } from 'react-imgix'

import getWindow from '~/utils/get-window'

const toFixed = (dp, value) => +value.toFixed(dp)

const createUrl = ({ name, height = 80, width = 128, imgixParams, fit = 'fill', fill = 'solid' }) => {
  const params = {
    ...defaultImigxParams,
    ...imgixParams,
    fit,
    width,
    height,
    fill
  }

  const providerImg = assignImgixLogo(name)
  const newUrl = name ? `${buildURL(imgixUrl(providerImg), params)}` : ''
  return newUrl
}

const generateProviderImage = (name, options = {}) => {
  const dpr = toFixed(2, getWindow().devicePixelRatio || 1)
  const imgixSrc = createUrl({ name, dpr, imgixParams: { auto: 'compress, format' }, ...options })
  return imgixSrc
}

export default generateProviderImage
